import {
    IClassificacaoCliente,
    IContrato,
    IListaGrupoContrato,
} from "../../../Interfaces/Cobranca/Contrato/ContratoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export const ListarContratosDistribuidosService = () =>
    Service(
        Axios.get<Array<IContrato>>(
            `/cobranca/filaatendimentos/listarcontratosdistribuidos`
        )
    );

export const ListarContratosNaoDistribuidosService = () =>
    Service(
        Axios.get<Array<IContrato>>(
            `/cobranca/filaatendimentos/listarcontratosnaodistribuidos`
        )
    );

export const InserirContratosCampanhaService = (
    ID_GRUPO: number,
    lstCasoCobrancaFato: Array<IContrato>
) =>
    Service(
        Axios.post<Array<IContrato>>(
            `/cobranca/filaatendimentos/inserircontratoscampanha?ID_GRUPO=${ID_GRUPO}`,
            lstCasoCobrancaFato
        )
    );

export const ExcluirContratosService = (
    ID_CASO_COBRANCA_FILA_ATENDIMENTO: number
) =>
    Service(
        Axios.delete<Array<IContrato>>(
            `/cobranca/filaatendimentos/excluircontratos?ID_CASO_COBRANCA_FILA_ATENDIMENTO=${ID_CASO_COBRANCA_FILA_ATENDIMENTO}`
        )
    );

export const ExcluirContratosPorGrupoService = (ID_GRUPO: number) =>
    Service(
        Axios.delete<Array<IContrato>>(
            `/cobranca/filaatendimentos/excluircontratosporgrupo?ID_GRUPO=${ID_GRUPO}`
        )
    );

export const ExportarContratosDistribuidosService = () =>
    Service(
        Axios.get<Blob>(
            `/cobranca/filaatendimentos/exportarrcontratosdistribuidos`,
            { responseType: "blob" }
        )
    );

export const ExportarContratosNaoDistribuidosService = () =>
    Service(
        Axios.get<Blob>(
            `/cobranca/filaatendimentos/exportarrcontratosnaodistribuidos`,
            { responseType: "blob" }
        )
    );

export const ListarContratosDistribuidosPorGruposService = () =>
    Service(
        Axios.get<Array<IListaGrupoContrato>>(
            `/cobranca/filaatendimentos/listarcontratosdistribuidosporgrupos`
        )
    );

export async function ExcluirContratosCampanhaService(
    requestBody: Array<IContrato>
) {
    return Service(
        Axios.delete(`/cobranca/filaatendimentos/excluircontratoscampanha`, {
            data: requestBody,
        })
    );
}

export async function AlterarClassificacaoClienteService(
    requestBody: IClassificacaoCliente
) {
    return Service(
        Axios.post(
            `/cobranca/classificacaocobranca/alterarclassificacaocliente`,
            requestBody
        )
    );
}

export async function ExcluirContratosEmMassaService(requestBody: number[]) {
    return Service(
        Axios.delete(`/cobranca/filaatendimentos/excluircontratosemmassa`, {
            data: requestBody,
        })
    );
}
